import React from 'react';
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import Button from "@material-ui/core/Button";
import {ADMIN} from "core/utils/permissions";
import PagePermission from "components/permission/PagePermission";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanel from "components/panel/BsPanel";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import PasswordFilters from "./PasswordFilters";
import PASSWORDS_TABLE from "./passwords-table";
import PlusIcon from "assets/img/plus.svg";
import {loadPasswords} from "core/actions/password-actions";

const queryString = require('query-string');

class Passwords extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        password: query.password != null ? query.password : '',
        status: query.status != null ? query.status : '',
      }
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.password = this.state.fields.password;
    params.status = this.state.fields.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.password;
    delete params.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        password: '',
        status: ''
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadPasswords(this.props.match.params.systemId, this.prepareQuery(query));
  }

  addPassword = () => {
    this.props.history.push('/system/' + this.props.match.params.systemId + '/edit-settings/create-password')
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }

    return query
  }

  onRowClick = (row) => {
    this.props.history.push('/system/' + this.props.match.params.systemId + '/edit-settings/password/' + row.id)
  }

  render() {
    return (
        <BsPanel padding={true}>
          <PagePermission anonymous={false} permission={ADMIN}/>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <>
                <Button variant="contained" color="primary" type="submit" onClick={this.addPassword}>
                  <PlusIcon/>&nbsp;<Trans i18nKey="general.add"/>
                </Button>
              </>
            }>
              <Trans i18nKey="passwords.title"/>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <PasswordFilters fields={this.state.fields}
                             onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={PASSWORDS_TABLE}
                       content={this.props.passwords}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    passwords: state.systemPassword.passwords,
    loading: state.systemPassword.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadPasswords: (systemId, query) => {
      dispatch(loadPasswords(systemId, query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Passwords);
